if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cartNotification) {
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      }
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      if (this._appstleSubmitLock) return;
      this._appstleSubmitLock = true;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            if (this.querySelector('.wbquicksuccess')) this.querySelector('.wbquicksuccess').classList.add('hidden'); // Webibazaar Quickview Message
            this.handleErrorMessage(response.description);
            return;
          }

          if (this.cartNotification) this.cartNotification.renderContents(response);
          if (this.querySelector('.wbquicksuccess')) this.querySelector('.wbquicksuccess').classList.remove('hidden'); // Webibazaar Quickview Message
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          setTimeout(() => { this._appstleSubmitLock = false; }, 2000);
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
